export {IF_PARTNER_ONLINE};

import {AttributeLink, AttributeSetup} from '@acng/frontend-stargazer';
import {WatchGroup} from '@acng/frontend-relativity';
import {attributeSelector} from '@acng/frontend-bounty/dom/query.js';
import {createConditional as Conditional} from 'nova';

import {ctxAmateur} from '../context/amateur.js';
import {ctxOnline} from '../service/online.js';

/**
 * Show the partner's online status.
 *
 * Remove the element from the document while the {@link ctxAmateur | partner} is not online according to
 * {@link ctxOnline}.
 *
 * @example
 *
 * ```html
 * <img if-partner-online src="icon/online.svg" />
 * ```
 *
 * @group DOM Attribute
 */
const IF_PARTNER_ONLINE = 'if-partner-online';

AttributeSetup(IF_PARTNER_ONLINE, (name) => {
  const watch = WatchGroup(attributeSelector(name), ctxAmateur, ctxOnline);

  AttributeLink(name, (element) => {
    const toggle = Conditional(element);

    return (element) => watch(element, (element, [partner]) => toggle(!!partner?.isOnline()));
  });
});
